export default __webpack_public_path__ + "static/media/icon-logout.f8ac3093.svg";